import { Injectable } from '@angular/core';
import { switchMap } from 'rxjs/operators';
import { RequestService } from 'src/app/core/service/request.service';
import { TextService } from '../core/service/text.service';
import { ModuleName } from 'src/app/core/types/WorkFlowActivity';

@Injectable({
  providedIn: 'root',
})
export class WorkflowService {
  constructor(
    private restApi: RequestService,
    private textService: TextService
  ) {}

  createWorkflow(data) {
    return this.restApi.request('POST', '/api/v5/work-flow-activities', data);
  }

  getBcCoordinatorWorkflowActivity(id: number, module: ModuleName) {
    return this.restApi.request('GET', '/api/v5/work-flow-activities', {
      'moduleName.equals': module,
      'moduleRefId.equals': id.toString(),
      'teamSequence.equals': 0,
    });
  }

  submitForReview(workflow) {
    return this.restApi.request(
      'PUT',
      '/api/v5/work-flow-activities/review',
      workflow
    );
  }

  getWorkFlowActivites(id: number, module: ModuleName) {
    return this.restApi.request('GET', '/api/v5/work-flow-activities', {
      'moduleName.equals': module,
      'moduleRefId.equals': id.toString(),
    });
  }

  getWorkFlowActivitesBCPReport(id: number, module: ModuleName[]) {
    return this.restApi.request('GET', '/api/v5/work-flow-activities', {
      'moduleName.in': module,
      'moduleRefId.equals': id.toString(),
    });
  }

  getWorkflowActivity(id) {
    return this.restApi.get(`/api/v5/work-flow-activities/${id}`);
  }
  updateWorkflowActivity(data) {
    return this.restApi.request('PUT', `/api/v5/work-flow-activities`, data);
  }

  getWorkFlowStates() {
    return this.restApi
      .request('GET', '/api/v5/work-flow-states', { page: 0, size: 100 })
      .pipe(
        switchMap((resp) => {
          return this.textService.convert(resp.body);
        })
      );
  }
}
